<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div *ngIf="isWindFarmView || isPowerStationAdminView" class="col-md-2 cardtabs-wrapper">
            <div *ngIf="isPowerStationView && latestOutage" >

              <h4 class="card-title">Next Outage</h4>
              <br>
              <div style="text-align: center;">
                <large-number-display
                  [number]="groupedResponses[TrainingCourseStateType.Completed]"
                  [text]="'accepted out of ' + totalResponsesNeeded + ' invited'"
                  [class]="'blue'"
                  (onClick)="goToOutageResponses(latestOutage.trainingId)">
                </large-number-display>
              </div>
              <p>{{latestOutage.trainingName}}</p>
              <p *ngIf="latestOutage.description">{{latestOutage.description}}</p>
            </div>

            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div [ngClass]="isWindFarmView || isPowerStationAdminView ? 'col-md-10' : 'col-md-12'">
              <card-section-header
                  title="Workers"
                  icon="fas fa-list"
                  buttonLabel="ADD WORKER"
                  buttonIcon="fas fa-plus"
                  [showButton]="isWindFarmView"
                  [buttonDisabled]="addWorkerButtonDisabled"
                  (buttonClick)="toggleAddWorkerModal()">
              </card-section-header>
            <div class="mb-2 animated fadeIn">
              <!-- Filters -->
              <div class="row">
                <div class="col-md-12">
                  <div class="filter-flex-row">
                    <div>
                      <label>First Name</label>
                      <text-filter-box
                        placeholder="Filter by first name..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'firstName')">
                      </text-filter-box>
                    </div>
                    <div>
                      <label>Last Name</label>
                      <text-filter-box
                        placeholder="Filter by last name..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'lastName')">
                      </text-filter-box>
                    </div>
                    <div>
                      <label>Phone Number</label>
                      <text-filter-box
                        placeholder="Filter by phone number..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'phoneNumber')"
                        onlyNumbers>
                      </text-filter-box>
                    </div>
                    <div>
                      <label>Company Name</label>
                      <text-filter-box
                        placeholder="Filter by company name..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'company')">
                      </text-filter-box>
                    </div>
                    <div *ngIf="isFilterLoading" class="small-spinner">
                      <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12 d-flex justify-content-end">
                  <table-action-bar (toggleColumns)="columnOptionsSidebarVisible = true"></table-action-bar>
                </div>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="siteWorkers" selectionMode="single" [(selection)]="selectedSiteWorker" [autoLayout]="true"
                    (onRowSelect)="onRowSelect($event)" (onSort)="customSort($event)" [sortField]="defaultSortField" [lazy]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [pSortableColumn]="'workerUser.skylarkUser.user.lastName'">Name
                                <p-sortIcon [field]="'workerUser.skylarkUser.user.lastName'"></p-sortIcon>
                            </th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Username')" [pSortableColumn]="'workerUser.skylarkUser.user.login'">Username
                                <p-sortIcon [field]="'workerUser.skylarkUser.user.login'"></p-sortIcon>
                            </th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Phone')" >Phone</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Company')" [pSortableColumn]="'workerUser.maintenance.name'">Company
                                <p-sortIcon [field]="'workerUser.maintenance.name'"></p-sortIcon>
                            </th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Company')">Company Approved</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Competencies')" >Competencies</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Asset Categories')" >Asset Categories</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Guests Permitted')" >Guests Permitted</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Site Session Permitted')" >Site Session Permitted</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Site Delegate')" >Site Delegate</th>
                            <th *ngIf="hasInduction && tableOptions.visibleColumns.includes('Induction')">Induction</th>
                            <th class="table-cell-centered" [pSortableColumn]="'workerUser.skylarkUser.user.activated'">Activated
                                <p-sortIcon [field]="'workerUser.skylarkUser.user.activated'"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-worker>
                      <ng-container *ngIf="loading; else showRows">
                          <tr>
                            <td [attr.colspan]="20">
                              <skeleton-loading-row></skeleton-loading-row>
                            </td>
                          </tr>
                      </ng-container>
                      <ng-template #showRows>
                        <tr [pSelectableRow]="worker">
                          <td>
                            <a
                              [routerLink]="['/' + routeRole, 'workers', worker.workerUser.id, 'details']"
                              [queryParams]="{ backLink:  '/' + routeRole + '/sites/' + selectedSite.id + '/workers', siteOwnerId: selectedSite.siteOwner.id }"
                            >
                              {{ worker.workerUser.firstName }} {{ worker.workerUser.lastName }}
                            </a>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Username')" >{{ worker.workerUser.login }}</td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Phone')" >{{ worker.workerUser.workerUser.phoneNumber }}</td>
                          <td *ngIf="isSiteDelegate && tableOptions.visibleColumns.includes('Company')">
                              {{ worker.workerUser.workerUser.maintenance.name }}
                          </td>
                          <td *ngIf="!isSiteDelegate && tableOptions.visibleColumns.includes('Company')">
                            <a [routerLink]="['/' + routeRole, 'contractors', worker.workerUser.workerUser.maintenance.id, 'details']">
                              {{ worker.workerUser.workerUser.maintenance.name }}
                            </a>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Company')">
                            <span *ngIf="worker.contractorStatus === 'APPROVED'" class="badge badge-pill badge-success">Approved</span>
                            <span *ngIf="worker.contractorStatus !== 'APPROVED'" class="badge badge-pill badge-warning">Not Approved</span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Competencies')" >
                            <ng-container *ngIf="showHuntstownCompetencyColumn; else defaultCompetenciesColumn">
                              <ng-container *ngIf="hasReliableHuntstownCompetencies; else huntstownCompetencyLoading">
                                <ng-container *ngIf="worker.huntstownCompetencies as competencies">
                                  <a
                                    *ngIf="competencies.length"
                                    [routerLink]="['/' + routeRole, 'workers', worker.workerUser.id, 'manage-competencies']"
                                    [queryParams]="{ backLink:  '/' + routeRole + '/sites/' + selectedSite.id + '/workers', siteOwnerId: selectedSite.siteOwner.id }">
                                    <ng-container *ngFor="let competency of competencies">
                                      <span class="badge badge-pill mr-1 mb-1" [ngClass]="competency.badgeClass">
                                        {{ competency.label }} {{ competency.textDetail }}
                                        <ng-container *ngIf="competency.expiryDate">{{ competency.expiryDate | date : 'mediumDate' }}</ng-container>
                                      </span>
                                    </ng-container>
                                  </a>
                                </ng-container>
                              </ng-container>
                              <ng-template #huntstownCompetencyLoading>
                                <div class="skeleton competency-count-skeleton"></div>
                                <div class="skeleton competency-status-skeleton"></div>
                              </ng-template>
                            </ng-container>
                            <ng-template #defaultCompetenciesColumn>
                              <div class="competency-container">
                                <ng-container *ngIf="!hasReliableCompetencyCounts; else competencyCountsReady">
                                  <div class="skeleton competency-count-skeleton"></div>
                                  <div class="skeleton competency-status-skeleton"></div>
                                </ng-container>
                                <ng-template #competencyCountsReady>
                                  <a
                                    class="link-underline"
                                    [routerLink]="['/' + routeRole, 'workers', worker.workerUser.id, 'manage-competencies']"
                                    [queryParams]="{ backLink:  '/' + routeRole + '/sites/' + selectedSite.id + '/workers', siteOwnerId: selectedSite.siteOwner.id }">
                                    {{ getCompetencyCountLabel(worker) }}
                                  </a>
                                  <ng-container *ngIf="getCompetencyStatusItems(worker) as statusItems">
                                    <div class="competency-container__text-size" *ngIf="statusItems.length">
                                      <ng-container *ngFor="let item of statusItems; let last = last">
                                        <span [ngClass]="item.colorClass"><strong>{{ item.count }}</strong></span>
                                        <span> {{ item.label }}</span><span *ngIf="!last">, </span>
                                      </ng-container>
                                    </div>
                                  </ng-container>
                                </ng-template>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Asset Categories')">
                            <span *ngFor="let item of worker.assetCategories" class="badge badge-pill badge-success" [ngStyle]="{ 'background-color': item.color }">{{ item.name }}<br /></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Guests Permitted')" class="table-cell-centered">
                            <span *ngIf="worker.guestsPermitted"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.guestsPermitted"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Site Session Permitted')" class="table-cell-centered">
                            <span *ngIf="worker.managementDuty"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.managementDuty"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Site Delegate')" class="table-cell-centered">
                            <span *ngIf="worker.siteDelegate"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.siteDelegate"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="hasInduction && tableOptions.visibleColumns.includes('Induction')">
                            <ng-container *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Completed">
                              <span class="badge badge-pill badge-success">
                                valid until: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}
                              </span>
                            </ng-container>
                            <ng-container *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Expired">
                              <span class="badge badge-pill badge-warning">
                                expired on: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}
                              </span>
                                <ng-template *ngTemplateOutlet="reminderButton"></ng-template>
                            </ng-container>
                            <ng-container *ngIf="!worker.inductionForSite" >
                              <span class="badge badge-pill badge-danger">
                                Not Verified
                              </span>
                              <ng-template *ngTemplateOutlet="reminderButton"></ng-template>
                            </ng-container>

                            <ng-template #reminderButton>
                              <div>
                                <button
                                    type="button"
                                    class="btn btn-primary btn-link"
                                    [disabled]="worker.isSendingInductionReminder || worker.inductionReminderSent"
                                    (click)="$event.stopPropagation(); resendInductionReminder(worker)"
                                >
                                  <ng-container *ngIf="worker.isSendingInductionReminder">
                                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                    Sending...
                                  </ng-container>
                                  <ng-container *ngIf="!worker.isSendingInductionReminder">
                                    <span *ngIf="!worker.inductionReminderSent">Resend reminder</span>
                                    <span *ngIf="worker.inductionReminderSent">Reminder sent</span>
                                  </ng-container>
                                </button>
                              </div>
                            </ng-template>
                          </td>
                          <td class="table-cell-centered">
                            <ng-container *ngIf="worker.workerUser.activated; else notActivated">
                              <i class="fas fa-check-circle success"></i>
                            </ng-container>
                            <ng-template #notActivated>
                              <i class="fas fa-times-circle danger"></i>
                              <div>
                                <button type="button" class="btn btn-primary btn-link"
                                  [disabled]="worker.workerUser.isSendingInvite || worker.workerUser.inviteSent" (click)="$event.stopPropagation(); resendInvite(worker.workerUser)">
                                  <span *ngIf="!worker.workerUser.isSendingInvite && !worker.workerUser.inviteSent">Resend invite</span>
                                  <span *ngIf="worker.workerUser.isSendingInvite">
                                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                    Sending...
                                  </span>
                                  <span *ngIf="worker.workerUser.inviteSent">Invite sent</span>
                                </button>
                              </div>
                            </ng-template>
                          </td>
                        </tr>
                      </ng-template>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr *ngIf="loading">
                        <td [attr.colspan]="20">
                          <skeleton-loading-row></skeleton-loading-row>
                        </td>
                      </tr>
                      <tr *ngIf="!loading">
                        <td [attr.colspan]="12">No workers found for this site</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div class="card-footer">
                <p-paginator
                  #paginator
                  [rows]="pagination.size"
                  [totalRecords]="pagination.totalRecords"
                  [rowsPerPageOptions]="pageSizes"
                  (onPageChange)="paginate($event)">
                </p-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of ( isPowerStationView ? togglableColumnsPowerStation : togglableColumns )">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <div class="form-group" [ngClass]="!hasInduction ? 'text-muted' : ''">
    <p-checkbox name="togglableColumns" [disabled]="!hasInduction" [value]="'Induction'" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="'Induction'"></p-checkbox>
    <div class="text-muted small" *ngIf="!hasInduction">No induction on this site</div>
  </div>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>

<p-dialog
  header="Add Worker"
  [(visible)]="addExistingWorkerModal"
  modal="true"
  [baseZIndex]="1000000"
  styleClass="site-workers-add-worker-dialog">
  <form [formGroup]="addExistingWorkerForm" (ngSubmit)="onAddExistingWorkerFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Select Contractor<span class="required-star">*</span></label>
          <p-dropdown
            class="pDropdownCustom"
            [(ngModel)]="selectedContractor"
            (ngModelChange)="onSelectedContractorChange($event)"
            [ngModelOptions]="{ standalone: true }"
            [options]="contractors"
            optionLabel="label"
            placeholder="Select a contractor..."
            [style]="{ width: '100%' }"
            [disabled]="!contractors.length"
            filter="true">
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Select Worker<span class="required-star">*</span></label>
          <p-dropdown
            class="pDropdownCustom"
            [(ngModel)]="selectedContractorWorker"
            (ngModelChange)="onSelectedContractorWorkerChange($event)"
            [ngModelOptions]="{ standalone: true }"
            [options]="companyWorkers"
            optionLabel="label"
            placeholder="Select a worker..."
            [style]="{ width: '100%' }"
            [disabled]="!selectedContractor || !companyWorkers.length"
            filter="true"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12" *ngIf="selectedContractorWorker && !selectedContractorWorker.value.activated">
        <div class="alert alert-warning" role="alert"><i class="fas fa-info-circle"></i>&nbsp;Worker has not yet activated account</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Categories<span class="required-star">*</span></label>
          <p-multiSelect
            class="pMultiSelectCustom"
            formControlName="assetCategories"
            [options]="siteTypeAssetCategories"
            defaultLabel="Select Categories"
            optionLabel="label"
            [style]="{ width: '100%' }"
          >
          </p-multiSelect>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12" *ngIf="!hideGuestCheckbox">
        <div class="form-group form-group-checkbox">
          <label>Guests Permitted?</label>
          <p-checkbox class="form-control" formControlName="guestsPermitted" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-12" *ngIf="!hideSiteSessionsCheckbox">
        <div class="form-group form-group-checkbox">
          <label>Site Session Permitted?</label>
          <p-checkbox class="form-control" formControlName="managementDuty" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="addExistingWorkerModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onAddExistingWorkerFormSubmit()" [disabled]="isFormBeingSubmitted || !selectedContractorWorker || !addExistingWorkerForm.valid" class="my-2 btn btn-round btn-sm btn-success">Add Worker</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Site Worker" [(visible)]="editSiteWorkerModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editSiteWorkerForm" (ngSubmit)="onEditSiteWorkerFormSubmit()">
    <div class="row">
      <div class="col-md-12" *ngIf="siteTypeAssetCategories.length">
        <div class="form-group">
          <label>Categories<span class="required-star">*</span></label>
          <p-multiSelect class="form-control" formControlName="assetCategories" [options]="siteTypeAssetCategories" optionLabel="label" defaultLabel="Select Categories" [style]="{ width: '100%' }">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox">
          <label>Guests Permitted?</label>
          <p-checkbox class="form-control" formControlName="guestsPermitted" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-group-checkbox">
          <label>Site Session Permitted?</label>
          <p-checkbox class="form-control" formControlName="managementDuty" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-12" *ngIf="routeRole !== 'site-delegate' || isRegionalManager">
        <div class="form-group form-group-checkbox">
          <label>Site Delegate?</label>
          <p-checkbox class="form-control" formControlName="siteDelegate" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editSiteWorkerModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditSiteWorkerFormSubmit()" [disabled]="isFormBeingSubmitted || !editSiteWorkerForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
